import { call, put } from 'redux-saga/effects';
import { showAlert } from '../../alertSlice';
import { setMediaVerifying, setHeaderHandle, setHeaderHandleError } from '../../whatsappSlice';
import { performMediaVerification } from './mediaVerificationUtils';

export function* handleVerifyMediaTemplate(action) {
  try {
    yield put(setMediaVerifying(true));
    yield put(setHeaderHandleError(null));
    yield put(setHeaderHandle(null));

    const result = yield call(performMediaVerification, action.payload);

    if (result?.success) {
      yield put(setHeaderHandle(result.headerHandle));
      yield put(showAlert({ message: 'Media verified successfully', type: 'success' }));
    } else {
      const errorMsg = result?.error || 'Failed to verify media';
      yield put(setHeaderHandleError(errorMsg));
      yield put(showAlert({ message: errorMsg, type: 'error' }));
    }
  } catch (error) {
    const errorMsg = error.message || 'Error occurred while verifying media';
    yield put(setHeaderHandleError(errorMsg));
    yield put(showAlert({ message: errorMsg, type: 'error' }));
  } finally {
    yield put(setMediaVerifying(false));
  }
}
